import AIWarningIcon from './AIWarningIcon.png';

export const getAIGenerateImagesStyles = ({ imageWidth, gap, marginToSelector }) => (_, { palette = {} }) => ({
  '@global': {
    '@keyframes loading_indicator': {
      '0%': { backgroundPosition: '-50%' },
      '100%': { backgroundPosition: '150%' },
    },
    '@keyframes loading_placeholder': {
      '0%': { backgroundPosition: '87.5%' }, // The whole background is 800% and we use only the 0-7 range
      '100%': { backgroundPosition: '0%' },
    },
  },
  main: {
    marginTop: '24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '606px',
  },
  entry: {
    marginTop: '22px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  searchBar: {
  },
  promptInput: {
  },
  remainingText: {
    '& span': {
      color: palette.neutralSecondary,
    },
  },
  actionBottomText: {
    width: '100%',
    '& span': {
      color: palette.neutralSecondary,
    },
  },
  header: {
    marginBottom: '16px',
    textAlign: 'center',
    width: '62%',
  },
  actionSection: {
    width: '100%',
  },
  actionText: {
    marginTop: '32px',
    marginBottom: '16px',
  },
  actionImages: {
    width: `${(imageWidth * 2)}px`,
    position: 'relative',
  },
  imageGridCellContainer: {
    width: '100%',
    height: '100%',
    borderRadius: '6px',
  },
  tilesGridCellContent: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    padding: gap,
    boxSizing: 'border-box',
    borderRadius: '6px',
  },
  cellContent: {
    position: 'relative',
    flexGrow: 1,
    flexShrink: 1,
    '& .cell-image-frame': {
      overflow: 'hidden',
      borderRadius: '6px',
      margin: `${marginToSelector}px`,
    },
    '& .grid-cell-selection-decorator': {
      outlineWidth: '2px',
    },
    '& .selected-checkbox': {
      visibility: 'hidden',
    },
  },
  cellContentShadow: {
    filter: 'drop-shadow(0px 0.6px 1.8px rgba(0, 0, 0, 0.1)) drop-shadow(0px 3.2px 7.2px rgba(0, 0, 0, 0.13))',
  },
  selectedCellContent: {
    '& .selected-checkbox': {
      visibility: 'unset',
      right: '8px',
      '& .ms-Checkbox-checkbox': {
        border: 'none',
        outline: 'none',
      },
    },
  },
  loadingPlaceholder: {
    width: '100%',
    height: '100%',
  },
  loadingImage: {
    backgroundColor: '#EDEBE9',
    borderRadius: '6px',
    margin: `${marginToSelector}px`,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  loadingImageAnimation: {
    backgroundSize: '800%',
    background: 'linear-gradient(to right, #EDEBE9 0%, #EDEBE9 12.5%, #F3F2F1 25%, #F3F2F1 87.5%, #EDEBE9 100%)',
    animation: 'loading_placeholder 3s linear infinite',
  },
  loadingSection: {
    '& .ms-Button': {
      marginTop: '8px',
    },
    textAlign: 'center',
    marginTop: '32px',
    marginBottom: '32px',
  },
  loadingIndicator: {
    width: '100%',
    borderRadius: '2px',
    height: '4px',
    background: 'linear-gradient(to right, rgba(0, 120, 212, 0) 0%, #213AD5 50%, rgba(0, 120, 212, 0) 100%)',
    backgroundSize: '33%',
    backgroundRepeat: 'no-repeat',
    animation: 'loading_indicator 3s linear infinite',
    backgroundColor: '#E6E6E6',
  },
  AIGenerateImages: {
    margin: '0 auto',
    '& .user-error': {
      width: '100%',
    },
    '& div[role="alert"]': {
      textAlign: 'left',
      '& .error': {
        color: '#A80000',
        fontSize: '12px',
        lineHeight: '16px',
      },
    },
    '& $main': {
      '& $searchBar': {
        width: '100%',
        display: 'flex',
        '& $promptInput': {
          flexGrow: 1,
          marginRight: '12px',
        },
      },
      '& $remainingText': {
        width: '100%',
        marginTop: '8px',
      },
    },
    '& $entry': {
      '& $searchBar': {
        textAlign: 'center',
        '& $promptInput': {
          width: '435px',
        },
        '& .ms-Button': {
          marginTop: '16px',
          marginBottom: '16px',
        },
      },
      '& $remainingText': {
        width: '56%',
        textAlign: 'center',
      },
    },
  },
  imageCellLabelContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'absolute',
    left: 12,
    bottom: 12,
    zIndex: 1,

    '& .created-with-ai-label': {
      display: 'flex',
      background: 'red',
      padding: 0,
      margin: 0,
      height: 24,
      backgroundColor: '#FFFFFFBB',

      '& .label-icon': {
        margin: 0,
      },
    },
  },

  brandDetectionConfirmationContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    padding: [16, 24],
    marginTop: 32,
    gap: '16px',
    borderRadius: 4,
    border: '1px solid var(--neutrals-web-gray-40-e-1-dfdd, #E1DFDD)',
    background: '#FFF',

    '& .ai-warning-icon': {
      width: 128,
      height: 128,
      flexShrink: 0,
      backgroundImage: `url("${AIWarningIcon}")`,
      backgroundSize: [128, 128],
      marginRight: 16,
    },

    '& .confirmation-content': {
      fontFamily: 'Segoe UI',
      fontStyle: 'normal',
      '& .confirmation-content-title': {
        color: '#000',
        fontSize: 18,
        fontWeight: 600,
        lineHeight: '24px',
      },
      '& .confirmation-content-text': {
        color: '#605E5C',
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '20px',
        marginTop: 4,
        marginBottom: 12,
      },
      '& .confirmation-content-action': {
        display: 'flex',
        '& .confirmation-content-checkbox': {
          marginRight: 4,
          alignItems: 'flex-start',

          '& button': {
            marginTop: 4,
          },
        },
      },
    },
  },
});
